import React from "react";
import {ReactSession} from "react-client-session";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    CardContent,
    Checkbox,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    Grid,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    Table,
    TableCell,
    Typography
} from '@mui/material'
import rieptope from "../img/venduto/rieptope.png";
import riepilogoiva from "../img/venduto/riepilogoiva.png";
import visven from "../img/venduto/visven.png";
import incassiLogo from "../img/venduto/incassi.png";
import statisticheLogo from "../img/venduto/statistiche.png";

import dettope from "../img/venduto/dettope.png";
import axios from "axios";
import CollapsibleTableVendite from "./tabelle/CollapsibleTableVendite";
import CollapsibleTableAltreOperazioni from "./tabelle/CollapsibleTableAltreOperazioni";

import {Card} from "react-bootstrap";
import {loading} from "./loading";
import {oggi} from "../utility/returnDate"
import VariabiliGlobali from "../Back/VariabiliGlobali";
import FiltroSceltaNegozio from "./filtri/FiltroSceltaNegozio";
import FiltroSceltaData from "./filtri/FiltroSceltaData";
import NessunRisultato from "./NessunRisultato";
import FiltriTotali from "./filtri/FiltriTotali";
import FiltriArticoliINV, {dammiArticoli} from "./filtri/FiltriArticoliINV";
import TableCtrNeg from "./tabelle/Table";
import theme from "../theme";
import ChartComponent from "./ChartComponent";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import {BottoneInizioPagina} from "./bottoni/BottoneInizioPagina";
import {BottoneFinePagina} from "./bottoni/BottoneFinePagina";

export class Cassa extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            dataInizio: oggi(),
            dataFine: oggi(),
            sceltaoperazione: '0',
            tipioperazioni: [],
            loading: false,
            vendite: [],
            altreOpe: [],
            dettaltreOpe: [],
            statCassaTab: [],
            riepCassaDett: [],
            tabellariepIva: [],
            doveMiTrovo: 'venduto',
            visualizzazione: 'Giornaliero',
            tabellaIncassi: [],
            sceltanegozio: 'Tutti',
            imponibili: false,
            descrizione: "",
            marca: "",
            reparto: "",
            ricercaEffettuata: false,
            filtrototale: "XXX",
            promo: "0",
            preAcq: "0",
            idpromo: "",
            arrVAR: [false, "0001-01-01", "0001-01-01", '0', '', '', '0', '', '0'],
        };
        this.idmagazzino = ReactSession.get("idmagazzino");
    }

    componentDidMount() {
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.cambiaNegozio = this.cambiaNegozio.bind(this);
        this.chiediTipoOperazione();
        this.handleChangeDataInizio = this.handleChangeDataInizio.bind(this);
        this.handleChangeDataFine = this.handleChangeDataFine.bind(this);
        this.handleChangeArticolo = this.handleChangeArticolo.bind(this);
        this.handleChangeTotali = this.handleChangeTotali.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleClickOpen = this.handleClickOpen.bind(this);
    }

    resettaFiltri() {
        this.setState({descrizione: ""})
        this.setState({marca: ""})
        this.setState({reparto: "0"})
        this.setState({soloReparti: false})
        this.setState({soloDiversi: false})
        this.setState({filtroGiac: 'Giacenza > 0'})
        this.setState({filtroSceltaPreMag: 'Prezzo vendita'})
        this.setState({filtroSceltaPreNeg: 'Prezzo vendita'})
        this.setState({promo: "0"})
        this.setState({imponibili: false})
        this.setState({idpromo: ""})
        this.setState({arrVAR: [false, "0001-01-01", "0001-01-01", '0', '', '', '0', '', '0']});
    }

    cambiaNegozio(variabile) {
        this.setState({sceltanegozio: variabile})
    }

    handleChangeDataInizio(variabile) {
        this.setState({dataInizio: variabile})
    }

    handleChangeTotali(variabile, variabile2) {
        let varia = "XXX";
        if (variabile.toString().startsWith("Scelta")) {
            varia = "XXX";
        } else {
            if (variabile2.toString().trim().length > 0) {
                if (!(isNaN(variabile2))) {
                    varia = variabile + '' + variabile2;
                }
            }
        }
        this.setState({filtrototale: varia})
    }

    handleChangeDataFine(variabile) {
        this.setState({dataFine: variabile})
    }

    handleChangeArticolo(descrizione, marca, reparto, promo, arrVAR, idpromo) {
        this.setState({descrizione: descrizione})
        this.setState({marca: marca})
        this.setState({reparto: reparto})
        this.setState({promo: promo})
        this.setState({arrVAR: arrVAR})
        this.setState({idpromo: idpromo})

    }

    handleChange(event, provenienza) {
        if (provenienza === 'visVen') {
            this.setState({doveMiTrovo: 'visVen'})
        }
        if (provenienza === 'riepAltreOpe') {
            this.setState({doveMiTrovo: 'riepAltreOpe'})
        }
        if (provenienza === 'dettAltreOpe') {
            this.setState({doveMiTrovo: 'dettAltreOpe'})
        }
        if (provenienza === 'incassi') {
            this.setState({doveMiTrovo: 'incassi'})
        }
        if (provenienza === 'statCassa') {
            this.setState({doveMiTrovo: 'statCassa'})
        }
        if (provenienza === 'riepIva') {
            this.setState({doveMiTrovo: 'riepIva'})
        }
        if (provenienza === 'sceltaoperazione') {
            this.setState({sceltaoperazione: event.target.value})
        }
        if (provenienza === 'visualizzazione') {
            this.setState({visualizzazione: event.target.value});
        }
        if (provenienza === 'preAcq') {
            this.setState({preAcq: event.target.value});
        }
        if (provenienza === 'imponibili') {
            if (this.state.imponibili === true) {
                this.setState({imponibili: false});
            } else {
                this.setState({imponibili: true});
            }
        }

    }


    async handleSubmit(event) {
        event.preventDefault();
        if (this.state.doveMiTrovo === 'visVen') {
            if (this.state.sceltanegozio === '0') {
                alert("Seleziona un negozio per effettuare la ricerca")
            } else {
                ///controllonegozi/dettaglioVendite
                this.setState({loading: true})
                let dataini = this.state.dataInizio
                //let datafine = this.state.dataFine
                let sceltanegozio = this.state.sceltanegozio
                const params = new URLSearchParams();
                params.append('idasterneg', sceltanegozio);
                params.append('dataInizio', dataini);
                params.append('filtrototale', this.state.filtrototale);
                //params.append('dataFine', datafine);
                const config = {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                }
                let url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/dettaglioVendite';
                axios.post(url, params, config)
                    .then((response) => {
                        this.setState({vendite: ''});
                        this.setState({vendite: response.data});
                        this.setState({loading: false})
                    })
                    .catch((error) => {
                        console.log('Errore: ' + error);
                        alert(error);
                    })

                params.append('dataFine', dataini);

                url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/riepCassaDett';
                axios.post(url, params, config)
                    .then((response) => {
                        this.setState({riepCassaDett: response.data});
                    })
                    .catch((error) => {
                        console.log('Errore: ' + error);
                        alert(error);
                    })
            }
        }
        if (this.state.doveMiTrovo === 'riepAltreOpe') {
            this.setState({loading: true})
            let dataini = this.state.dataInizio
            let sceltanegozio = this.state.sceltanegozio
            const params = new URLSearchParams();
            params.append('idmagazzino', this.idmagazzino);
            params.append('dataInizio', dataini);
            params.append('sceltanegozio', sceltanegozio);
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }
            const url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/riepAltreOpe';
            axios.post(url, params, config)
                .then((response) => {
                    this.setState({altreOpe: response.data});
                    this.setState({loading: false})
                })
                .catch((error) => {
                    console.log('Errore: ' + error);
                    alert(error);
                })
            ///controllonegozi/riepAltreOpe
        }
        if (this.state.doveMiTrovo === 'dettAltreOpe') {
            this.setState({loading: true})
            let dataini = this.state.dataInizio
            //let datafine = this.state.dataFine
            const params = new URLSearchParams();
            let sceltanegozio = this.state.sceltanegozio
            let sceltaoperazione = this.state.sceltaoperazione
            params.append('dataInizio', dataini);
            params.append('idmagazzino', this.idmagazzino);
            params.append('negozio', sceltanegozio);
            params.append('sceltaoperazione', sceltaoperazione);

            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }
            const url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/dettAltreOpe';
            axios.post(url, params, config)
                .then((response) => {
                    this.setState({dettaltreOpe: response.data});
                    this.setState({loading: false})
                })
                .catch((error) => {
                    console.log('Errore: ' + error);
                    alert(error);
                })
        }
        if (this.state.doveMiTrovo === 'incassi') {
            event.preventDefault();
            this.setState({loading: true})
            let dataini = this.state.dataInizio
            let datafine = this.state.dataFine
            let visualizzazione = this.state.visualizzazione
            let sceltanegozio = this.state.sceltanegozio
            const params = new URLSearchParams();
            params.append('idmagazzino', this.idmagazzino);
            params.append('dataInizio', dataini);
            params.append('sceltanegozio', sceltanegozio);
            params.append('dataFine', datafine);
            params.append('visualizzazione', visualizzazione);
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }
            const url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/TabellaIncasso';
            axios.post(url, params, config)
                .then((response) => {
                    this.setState({tabellaIncassi: ''});
                    this.setState({tabellaIncassi: response.data});
                    this.setState({loading: false})
                })
                .catch((error) => {
                    console.log('Errore: ' + error);
                    alert(error);
                })
        }
        if (this.state.doveMiTrovo === 'statCassa') {
            event.preventDefault();
            this.setState({loading: true})
            let dataini = this.state.dataInizio
            let datafine = this.state.dataFine
            let sceltanegozio = this.state.sceltanegozio
            let imponibili = this.state.imponibili
            let preAcq = this.state.preAcq;
            let articoli = "";
            if (sceltanegozio.toString().toUpperCase() !== 'TUTTI') {
                articoli = await dammiArticoli(this.state.descrizione, this.state.marca, this.state.reparto, this.state.promo, this.state.arrVAR, sceltanegozio, this.state.idpromo)
            } else {
                articoli = await dammiArticoli(this.state.descrizione, this.state.marca, this.state.reparto, this.state.promo, this.state.arrVAR, '0', this.state.idpromo)
            }
            const params = new URLSearchParams();
            params.append('idmagazzino', this.idmagazzino);
            params.append('dataInizio', dataini);
            params.append('negozio', sceltanegozio);
            params.append('dataFine', datafine);
            params.append('imponibili', imponibili);
            params.append('articoli', articoli);
            params.append('preAcq', preAcq);
            params.append('filtrototale', this.state.filtrototale);

            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }
            const url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/TabellaStatisticheCassa';
            axios.post(url, params, config)
                .then((response) => {
                    this.setState({statCassaTab: ''});
                    this.setState({statCassaTab: response.data});
                    this.setState({loading: false})
                })
                .catch((error) => {
                    console.log('Errore: ' + error);
                    alert(error);
                })
        }
        if (this.state.doveMiTrovo === 'riepIva') {
            event.preventDefault();
            this.setState({loading: true})
            let dataini = this.state.dataInizio
            let datafine = this.state.dataFine
            let sceltanegozio = this.state.sceltanegozio
            const params = new URLSearchParams();
            params.append('idmagazzino', this.idmagazzino);
            params.append('dataInizio', dataini);
            params.append('sceltanegozio', sceltanegozio);
            params.append('dataFine', datafine);
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }
            const url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/riepIva';
            axios.post(url, params, config)
                .then((response) => {
                    this.setState({tabellariepIva: response.data});
                    this.setState({loading: false})
                })
                .catch((error) => {
                    console.log('Errore: ' + error);
                    alert(error);
                })
        }
        this.setState({ricercaEffettuata: true})
    }


    chiediTipoOperazione() {
        const params = new URLSearchParams();
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        }
        const url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/DammiTipiOperazioni';
        axios.post(url, params, config)
            .then((response) => {
                this.setState({tipioperazioni: response.data})
            })
            .catch((error) => {
                console.log('Errore: ' + error);
                alert(JSON.stringify(error))
            })
    }


    landing() {
        return (
            <div>
                <Grid className="center" container direction="column" spacing={3}>
                    <Grid item>
                        <Card variant="outlined" sx={{minWidth: 275}}>
                            <CardContent style={{backgroundColor: '#ECECFB'}} className="elemento">
                                <img id="visVen"
                                     onClick={(e) => this.handleChange(e, "incassi")}
                                     src={incassiLogo}
                                     alt=" "
                                     className="d-inline-block align-top"/> </CardContent>
                        </Card>
                    </Grid>
                    <Grid item>
                        <Card variant="outlined" sx={{minWidth: 275}}>
                            <CardContent style={{backgroundColor: '#ECECFB'}} className="elemento">
                                <img id="visVen"
                                     onClick={(e) => this.handleChange(e, "visVen")}
                                     src={visven}
                                     alt=" "
                                     className="d-inline-block align-top"/> </CardContent>
                        </Card>
                    </Grid>
                    <Grid item>
                        <Card variant="outlined" sx={{minWidth: 275}}>
                            <CardContent style={{backgroundColor: '#ECECFB'}} className="elemento">
                                <img id="statistiche"
                                     onClick={(e) => this.handleChange(e, "statCassa")}
                                     src={statisticheLogo}
                                     alt=" "
                                     className="d-inline-block align-top"
                                /> </CardContent>
                        </Card>
                    </Grid>
                    <Grid item>
                        <Card sx={{minWidth: 275}}>
                            <CardContent style={{backgroundColor: '#ECECFB'}} className="elemento">
                                <img id="riepAltreOpe"
                                     onClick={(e) => this.handleChange(e, "riepAltreOpe")}
                                     src={rieptope}
                                     alt=" "
                                     className="d-inline-block align-top"/> </CardContent>
                        </Card>
                    </Grid>
                    <Grid item>
                        <Card variant="outlined" sx={{minWidth: 275}}>
                            <CardContent style={{backgroundColor: '#ECECFB'}} className="elemento">
                                <img id="dettAltreOpe"
                                     onClick={(e) => this.handleChange(e, "dettAltreOpe")}
                                     src={dettope}
                                     alt=" "
                                     className="d-inline-block align-top"
                                /> </CardContent>
                        </Card>
                    </Grid>
                    <Grid item>
                        <Card variant="outlined" sx={{minWidth: 275}}>
                            <CardContent style={{backgroundColor: '#ECECFB'}} className="elemento">
                                <img id="dettAltreOpe"
                                     onClick={(e) => this.handleChange(e, "riepIva")}
                                     src={riepilogoiva}
                                     alt=" "
                                     className="d-inline-block align-top"
                                /> </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }

    incassi() {
        return (<div>
            <div>
                <Grid container direction="column" spacing={3}>
                    <Grid item>
                        <Card className="center" sx={{minWidth: 275}} spacing={3}>
                            <FiltroSceltaNegozio
                                visualizzaMaga={true}
                                sceltaneg={"Tutti"}
                                visualizzaTutti={true}
                                cambiaNegozio={this.cambiaNegozio}
                            />
                        </Card>
                    </Grid>
                    <Grid item>
                        <FiltroSceltaData
                            dataInizio={this.state.dataInizio}
                            dataFine={this.state.dataFine}
                            sceltaIntervallo={true}
                            handleChangeDataInizio={this.handleChangeDataInizio}
                            handleChangeDataFine={this.handleChangeDataFine}
                        />
                    </Grid>
                    <Grid item>
                        <Grid container direction="row" spacing={3}>
                            <Grid item>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="selectVisua"
                                    value={this.state.visualizzazione}
                                    label=''
                                    onChange={(e) => this.handleChange(e, "visualizzazione")}
                                >
                                    <MenuItem value={"Cumulativo"}>Cumulativo</MenuItem>
                                    <MenuItem value={"Giornaliero"}>Giornaliero</MenuItem>
                                    <MenuItem value={"Settimanale"}>Settimanale</MenuItem>
                                    <MenuItem value={"Mensile"}>Mensile</MenuItem>
                                </Select>
                                <FormHelperText>Visualizzazione</FormHelperText>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" style={theme.palette.verde} name='SubmitButton'
                                        onClick={this.handleSubmit}>Avvia
                                    ricerca</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {this.state.loading === true ? (
                    <div>
                        {loading()}
                    </div>
                ) : (
                    <div className='elemento'>
                        {this.state.tabellaIncassi.length > 0 && (
                            <div>
                                <Grid item>
                                    <Accordion style={{backgroundColor: '#ECECFB'}}>
                                        <AccordionSummary
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography>Clicka qui per visualizza il grafico</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <ChartComponent
                                                jsonData={this.state.tabellaIncassi}>
                                            </ChartComponent>
                                        </AccordionDetails>
                                    </Accordion>

                                </Grid>
                                <Divider/>
                                <TableCtrNeg data={this.state.tabellaIncassi}/>


                            </div>
                        )}
                        {this.state.tabellaIncassi.length === 0 && this.state.ricercaEffettuata && (
                            <NessunRisultato/>
                        )}
                    </div>
                )}
            </div>
        </div>)
    }


    visVen() {
        return (
            <Grid container direction="column" spacing={3}>
                <Grid item>
                    <Card className="center" sx={{minWidth: 275}} spacing={3}>
                        <FiltroSceltaNegozio
                            visualizzaMaga={true}
                            sceltaneg={this.idmagazzino}
                            visualizzaTutti={false}
                            cambiaNegozio={this.cambiaNegozio}
                        />
                    </Card>
                </Grid>
                <Grid item>
                    <Grid container direction="row" spacing={3}>
                        <Grid item>
                            <FiltroSceltaData
                                dataInizio={this.state.dataInizio}
                                dataFine={this.state.dataFine}
                                sceltaIntervallo={false}
                                handleChangeDataInizio={this.handleChangeDataInizio}
                                handleChangeDataFine={this.handleChangeDataFine}
                            />
                        </Grid>
                        <Grid item>
                            <FiltriTotali
                                handleChangeTotali={this.handleChangeTotali}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid item>
                        <Button variant="contained" style={theme.palette.verde} name='SubmitButton'
                                onClick={this.handleSubmit}>Avvia
                            ricerca</Button>
                    </Grid>
                </Grid>
                <Grid item>
                    {this.state.loading === true ? (
                        <div>
                            {loading()}
                        </div>
                    ) : (
                        <div>
                            {this.state.vendite.length > 0 && (
                                <div>
                                    <Divider/>
                                    <Grid container direction={"column"} spacing={3}>
                                        <Grid item>
                                            <Button variant="contained" color="primary"
                                                    onClick={e => this.handleClickOpen()}>
                                                Riepilogo casse
                                            </Button>
                                        </Grid>
                                        <Grid item>
                                            {CollapsibleTableVendite(this.state.vendite)}
                                        </Grid>
                                    </Grid>
                                    {this.dialog()}

                                </div>
                            )}
                            {this.state.vendite.length === 0 && this.state.ricercaEffettuata && (
                                <NessunRisultato/>
                            )}
                        </div>
                    )}
                </Grid>
            </Grid>
        )
    }

    dialog() {
        try {
            return (
                <Dialog fullScreen open={this.state.open} onClose={this.handleClose}
                        aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Riepilogo venduto casse</DialogTitle>
                    <DialogContent>

                        <Grid container direction={"column"} spacing={1}>
                            <Grid item>
                                <Button variant={"contained"} onClick={this.handleClose} color="primary">
                                    Esci
                                </Button>
                            </Grid>
                            <Grid item>
                                {this.state.riepCassaDett.length > 0 && (
                                    <TableContainer component={Paper}>
                                        <Table aria-label="collapsible table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="left"><b>Cassa</b></TableCell>
                                                    <TableCell align="left"><b>Numero vendite</b></TableCell>
                                                    <TableCell align="left"><b>F</b></TableCell>
                                                    <TableCell align="left"><b>NF</b></TableCell>
                                                    <TableCell align="left"><b>Contanti</b></TableCell>
                                                    <TableCell align="left"><b>Bancomat</b></TableCell>
                                                    <TableCell align="left"><b>Carta di credito</b></TableCell>
                                                    <TableCell align="left"><b>Buoni pasto</b></TableCell>
                                                    <TableCell align="left"><b>Non riscosso</b></TableCell>
                                                    <TableCell align="left"><b>Totale</b></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.state.riepCassaDett.map((rownnn, index) => (
                                                    <React.Fragment key={index}>
                                                        <TableRow>
                                                            <TableCell
                                                                align="left"><b>{rownnn.NUMCASSA.toString().replaceAll("_", "")}</b></TableCell>
                                                            <TableCell align="left"><b>{rownnn.numven}</b></TableCell>
                                                            <TableCell align="left"><b>{rownnn.numvenF}</b></TableCell>
                                                            <TableCell align="left"><b>{rownnn.numvenNF}</b></TableCell>
                                                            <TableCell
                                                                align="left"><b>{rownnn.SUMcontanti}</b></TableCell>
                                                            <TableCell
                                                                align="left"><b>{rownnn.sumBANCOMAT}</b></TableCell>
                                                            <TableCell
                                                                align="left"><b>{rownnn.sumBANCOMAT2}</b></TableCell>
                                                            <TableCell
                                                                align="left"><b>{rownnn.sumBPASTO}</b></TableCell>
                                                            <TableCell
                                                                align="left"><b>{rownnn.sumNRISCOSSO}</b></TableCell>
                                                            <TableCell
                                                                align="left"><b>{Number(Number(rownnn.SUMcontanti) + Number(rownnn.sumBANCOMAT) + Number(rownnn.sumBANCOMAT2) + Number(rownnn.sumBPASTO) + Number(rownnn.sumNRISCOSSO)).toFixed(2)}</b></TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell align="left"><b> </b></TableCell>
                                                            <TableCell align="left"><b> </b></TableCell>
                                                            <TableCell align="left"><b> </b></TableCell>
                                                            <TableCell align="left"><b>Totali F</b></TableCell>
                                                            <TableCell
                                                                align="left"><b>{rownnn.SUMcontantiF}</b></TableCell>
                                                            <TableCell
                                                                align="left"><b>{rownnn.sumBANCOMATF}</b></TableCell>
                                                            <TableCell
                                                                align="left"><b>{rownnn.sumBANCOMAT2F}</b></TableCell>
                                                            <TableCell
                                                                align="left"><b>{rownnn.sumBPASTOF}</b></TableCell>
                                                            <TableCell
                                                                align="left"><b>{rownnn.sumNRISCOSSOF}</b></TableCell>
                                                            <TableCell
                                                                align="left"><b>{Number(Number(rownnn.SUMcontantiF) + Number(rownnn.sumBANCOMATF) + Number(rownnn.sumBANCOMAT2F) + Number(rownnn.sumBPASTOF) + Number(rownnn.sumNRISCOSSOF)).toFixed(2)}</b></TableCell>

                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell align="left"><b></b></TableCell>
                                                            <TableCell align="left"><b></b></TableCell>
                                                            <TableCell align="left"><b></b></TableCell>
                                                            <TableCell align="left"><b>Totali NF</b></TableCell>
                                                            <TableCell
                                                                align="left"><b>{rownnn.SUMcontantiNF}</b></TableCell>
                                                            <TableCell
                                                                align="left"><b>{rownnn.sumBANCOMATNF}</b></TableCell>
                                                            <TableCell
                                                                align="left"><b>{rownnn.sumBANCOMAT2NF}</b></TableCell>
                                                            <TableCell
                                                                align="left"><b>{rownnn.sumBPASTONF}</b></TableCell>
                                                            <TableCell
                                                                align="left"><b>{rownnn.sumNRISCOSSONF}</b></TableCell>
                                                            <TableCell
                                                                align="left"><b>{Number(Number(rownnn.SUMcontantiNF) + Number(rownnn.sumBANCOMATNF) + Number(rownnn.sumBANCOMAT2NF) + Number(rownnn.sumBPASTONF) + Number(rownnn.sumNRISCOSSONF)).toFixed(2)}</b></TableCell>
                                                        </TableRow>
                                                    </React.Fragment>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                )}
                            </Grid>
                        </Grid>
                    </DialogContent>

                </Dialog>
            )
        } catch (e) {

        }

    }

    handleClose() {
        this.setState({open: false});
    };

    handleClickOpen() {
        this.setState({open: true});
    };

    riepAltreOpe() {
        return (
            <Grid container direction="column" spacing={3}>
                <Grid item>
                    <Card className="center" sx={{minWidth: 275}} spacing={3}>
                        <FiltroSceltaNegozio
                            visualizzaMaga={true}
                            sceltaneg={this.idmagazzino}
                            visualizzaTutti={true}
                            cambiaNegozio={this.cambiaNegozio}
                        />
                    </Card>
                </Grid>
                <Grid item>
                    <FiltroSceltaData
                        dataInizio={this.state.dataInizio}
                        dataFine={this.state.dataFine}
                        sceltaIntervallo={false}
                        handleChangeDataInizio={this.handleChangeDataInizio}
                        handleChangeDataFine={this.handleChangeDataFine}
                    />
                </Grid>
                <Grid item>
                    <Grid item>
                        <Button variant="contained" style={theme.palette.verde} name='SubmitButton'
                                onClick={this.handleSubmit}>Avvia
                            ricerca</Button>
                    </Grid>
                </Grid>
                <Grid item>
                    {this.state.loading === true ? (
                        <div>
                            {loading()}
                        </div>
                    ) : (
                        <div className='elemento'>
                            {this.state.altreOpe.length > 0 && (
                                <div>
                                    <Divider/>
                                    <TableCtrNeg data={this.state.altreOpe}/>
                                </div>
                            )}
                            {this.state.altreOpe.length === 0 && this.state.ricercaEffettuata && (
                                <NessunRisultato/>
                            )}
                        </div>
                    )}
                </Grid>
            </Grid>
        )
    }

    dettAltreOpe() {
        return (
            <Grid container direction="column" spacing={3}>
                <Grid item>
                    <Card className="center" sx={{minWidth: 275}} spacing={3}>
                        <FiltroSceltaNegozio
                            visualizzaMaga={true}
                            sceltaneg={this.idmagazzino}
                            visualizzaTutti={false}
                            cambiaNegozio={this.cambiaNegozio}
                        />
                    </Card>
                </Grid>
                <Grid item>
                    <FiltroSceltaData
                        dataInizio={this.state.dataInizio}
                        dataFine={this.state.dataFine}
                        sceltaIntervallo={false}
                        handleChangeDataInizio={this.handleChangeDataInizio}
                        handleChangeDataFine={this.handleChangeDataFine}
                    />
                </Grid>
                <Grid item>
                    <Grid container spacing={3}>
                        <Grid item>
                            <FormLabel component="legend">Scelta operazione</FormLabel>
                            <RadioGroup spacing={3} row aria-label="Scelta operazione" name="sceltaneg"
                                        value={this.state.sceltaoperazione}
                                        onChange={(e) => this.handleChange(e, "sceltaoperazione")}>
                                {this.getTipiOperazioni()}
                            </RadioGroup>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid item>
                        <Button variant="contained" style={theme.palette.verde} name='SubmitButton'
                                onClick={this.handleSubmit}>Avvia
                            ricerca</Button>
                    </Grid>
                </Grid>
                <Grid item>
                    {this.state.loading === true ? (
                        <div>
                            {loading()}
                        </div>
                    ) : (
                        <div>
                            {this.state.dettaltreOpe.length > 0 && (
                                <div>
                                    <Divider/>
                                    {CollapsibleTableAltreOperazioni(this.state.dettaltreOpe)}
                                </div>
                            )}
                            {this.state.dettaltreOpe.length === 0 && this.state.ricercaEffettuata && (
                                <NessunRisultato/>
                            )}
                        </div>
                    )}
                </Grid>
            </Grid>
        )
    }

    statCassa() {
        return (<div>
            <div>
                <Grid container direction="column" spacing={3}>
                    <Grid item>
                        <Card className="center" sx={{minWidth: 275}} spacing={3}>
                            <FiltroSceltaNegozio
                                visualizzaMaga={true}
                                sceltaneg={"Tutti"}
                                visualizzaTutti={true}
                                cambiaNegozio={this.cambiaNegozio}
                            />
                        </Card>
                    </Grid>
                    <Grid item>
                        <Grid container direction="row" spacing={3}>
                            <Grid item>
                                <FiltroSceltaData
                                    dataInizio={this.state.dataInizio}
                                    dataFine={this.state.dataFine}
                                    sceltaIntervallo={true}
                                    handleChangeDataInizio={this.handleChangeDataInizio}
                                    handleChangeDataFine={this.handleChangeDataFine}
                                />
                            </Grid>
                            <Grid item>
                                <FiltriTotali
                                    handleChangeTotali={this.handleChangeTotali}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container direction={"row"} spacing={3}>
                        <Grid item>
                            <FormLabel component="legend">
                                <Checkbox
                                    value={this.state.imponibili}
                                    onChange={(e) => this.handleChange(e, "imponibili")}
                                />Prezzi imponibili
                            </FormLabel>
                        </Grid>
                        <Grid item>
                            <Select
                                labelId="demo-simple-select-label"
                                id="filtroRep"
                                value={this.state.preAcq}
                                label=''
                                onChange={(e) => this.handleChange(e, "preAcq")}>
                                <MenuItem value={'0'}>Scelta prezzo acquisto</MenuItem>
                                <MenuItem value={'1'}>Articoli con prezzo acquisto</MenuItem>
                                <MenuItem value={'2'}>Articoli senza prezzo acquisto</MenuItem>

                            </Select>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <FiltriArticoliINV
                            descrizione=""
                            marca=""
                            reparto="0"
                            filtroGiac="0"
                            promo="0"
                            arrVAR={this.state.arrVAR}
                            handleChangeArticolo={this.handleChangeArticolo}
                            resettaFiltri={this.resettaFiltri}
                            idpromo=""
                        />
                    </Grid>
                    <Grid item>
                        <Button variant="contained" style={theme.palette.verde} name='SubmitButton'
                                onClick={this.handleSubmit}>Avvia
                            ricerca</Button>
                    </Grid>
                </Grid>
                {this.state.loading === true ? (
                    <div>
                        {loading()}
                    </div>
                ) : (
                    <div className='elemento'>
                        {this.state.statCassaTab.length > 0 && (
                            <div>
                                <Divider/>
                                <TableCtrNeg data={this.state.statCassaTab}/>
                            </div>
                        )}
                        {this.state.statCassaTab.length === 0 && this.state.ricercaEffettuata && (
                            <NessunRisultato/>
                        )}
                    </div>
                )}
            </div>
        </div>)
    }


    render() {
        return (
            <div>
                {this.state.doveMiTrovo === 'venduto' && (
                    <div>
                        {this.landing()}
                    </div>
                )}
                {this.state.doveMiTrovo === 'incassi' && (
                    <div>
                        <Card style={{backgroundColor: '#ECECFB'}} className="center" sx={{minWidth: 275}}>
                            <Typography>INCASSI </Typography>
                        </Card>
                        <br/>
                        {this.incassi()}
                    </div>
                )}
                {this.state.doveMiTrovo === 'visVen' && (
                    <div>
                        <Card style={{backgroundColor: '#ECECFB'}} className="center" sx={{minWidth: 275}}>
                            <Typography>VISUALIZZA VENDITE </Typography>
                        </Card>
                        <br/>
                        {this.visVen()}
                    </div>
                )}
                {this.state.doveMiTrovo === 'statCassa' && (
                    <div>
                        <Card style={{backgroundColor: '#ECECFB'}} className="center" sx={{minWidth: 275}}>
                            <Typography>STATISTICHE CASSA </Typography>
                        </Card>
                        <br/>
                        {this.statCassa()}
                    </div>
                )}
                {this.state.doveMiTrovo === 'riepAltreOpe' && (
                    <div>
                        <Card style={{backgroundColor: '#ECECFB'}} className="center" sx={{minWidth: 275}}>
                            <Typography>RIEPILOGO ALTRE OPERAZIONI </Typography>
                        </Card>
                        <br/>
                        {this.riepAltreOpe()}
                    </div>
                )}
                {this.state.doveMiTrovo === 'dettAltreOpe' && (
                    <div>
                        <Card style={{backgroundColor: '#ECECFB'}} className="center" sx={{minWidth: 275}}>
                            <Typography>DETTAGLIO ALTRE OPERAZIONI </Typography>
                        </Card>
                        <br/>
                        {this.dettAltreOpe()}
                    </div>
                )}
                {this.state.doveMiTrovo === 'riepIva' && (
                    <div>
                        <Card style={{backgroundColor: '#ECECFB'}} className="center" sx={{minWidth: 275}}>
                            <Typography>RIEPILOGO IVA </Typography>
                        </Card>
                        <br/>
                        {this.riepIva()}
                    </div>
                )}
            </div>
            //<form action="" method="post">

        )
    }

    getTipiOperazioni = function () {
        return this.state.tipioperazioni.map((el, i) =>
            <FormControlLabel value={el.tipoope} control={<Radio/>} label={el.causale}/>
        )
    }

    riepIva() {
        return (<div>
            <div>
                <Grid container direction="column" spacing={3}>
                    <Grid item>
                        <Card className="center" sx={{minWidth: 275}} spacing={3}>
                            <FiltroSceltaNegozio
                                visualizzaMaga={true}
                                sceltaneg={"Tutti"}
                                visualizzaTutti={false}
                                cambiaNegozio={this.cambiaNegozio}
                            />
                        </Card>
                    </Grid>
                    <Grid item>
                        <FiltroSceltaData
                            dataInizio={this.state.dataInizio}
                            dataFine={this.state.dataFine}
                            sceltaIntervallo={true}
                            handleChangeDataInizio={this.handleChangeDataInizio}
                            handleChangeDataFine={this.handleChangeDataFine}
                        />
                    </Grid>
                    <Grid item>
                        <Grid container direction="row" spacing={3}>
                            <Grid item>
                                <Button variant="contained" style={theme.palette.verde} name='SubmitButton'
                                        onClick={this.handleSubmit}>Avvia
                                    ricerca</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {this.state.loading === true ? (
                    <div>
                        {loading()}
                    </div>
                ) : (
                    <div className='elemento'>
                        {this.state.tabellariepIva.length > 0 && this.state.ricercaEffettuata && (
                            <Grid container direction="column" spacing={3}>
                                <Grid item>
                                    <BottoneFinePagina/>
                                </Grid>
                                <Grid item>
                                    <TableContainer component={Paper}>
                                        <Table aria-label="collapsible table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell><b>Negozio</b></TableCell>
                                                    <TableCell><b>22%</b></TableCell>
                                                    <TableCell><b>10%</b></TableCell>
                                                    <TableCell><b>5%</b></TableCell>
                                                    <TableCell><b>4%</b></TableCell>
                                                    <TableCell><b>0%</b></TableCell>
                                                    <TableCell><b>TOTALE</b></TableCell>

                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.state.tabellariepIva.map((ivaRow, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell><b>{ivaRow.negozio}</b></TableCell>
                                                        <TableCell><b>{ivaRow.IVA22_COMPL}</b></TableCell>
                                                        <TableCell><b>{ivaRow.IVA10_COMPL}</b></TableCell>
                                                        <TableCell><b>{ivaRow.IVA5_COMPL}</b></TableCell>
                                                        <TableCell><b>{ivaRow.IVA4_COMPL}</b></TableCell>
                                                        <TableCell><b>{ivaRow.IVA0_COMPL}</b></TableCell>
                                                        <TableCell><b>{ivaRow.TOTALE}</b></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>

                                        </Table>
                                    </TableContainer>
                                </Grid>
                                <Grid item>
                                    <Grid container direction="row" spacing={3}>
                                        <Grid item>
                                            <BottoneInizioPagina/>
                                        </Grid>
                                        <Grid item>
                                            <Button variant="contained"
                                                    onClick={(e) => this.display()}
                                            >STAMPA</Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>


                        )}
                    </div>
                )}
            </div>
        </div>)
    }

    display() {
        window.print();
    }
}
